@if (imageUrl) {
	<img [src]="imageUrl" alt="" class="promo-image" (error)="onImageError()" />
}
<ion-col class="automatic-promo-modal-root" style="text-align: center">
	<h2 class="promo-title">{{ title }}</h2>
	@if (description) {
		<p class="promo-description">{{ description }}</p>
	}
	@if (promoCode.simphonyCode) {
		<ion-button class="confirm-button ion-margin-bottom" shape="round" (click)="onConfirmClick()">
			{{ 'automatic_promo_modal.confirm' | translate }}
		</ion-button>
	}
	<br />
	<ion-button class="decline-button" shape="round" (click)="onDeclineClick()">
		{{ 'automatic_promo_modal.decline' | translate }}
	</ion-button>
</ion-col>
